import React, { Fragment, useState } from "react";
import SidebarWrapper from "./sidebar.style";
import Radium from "radium";
import NavList from "components/sidebar/NavList";
import { sidebarData } from "util/data/sidebar";
import { iconDemo, iconAppName } from "helper/constant";
import { NavLink } from "react-router-dom";
import IntlMessages from "util/intlMessages";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import ShareFlyer from "../share/ShareFlyer";
import { isIE, isMobile } from "react-device-detect";
import { reloadTutorial } from "views/Categories";
import { serverResponse } from "util/fakeServer";
import { connect } from "react-redux";
import { setIndexCarousel } from "../../redux/carousel/action";

import RetrieveCart from "../RetrieveCart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

import { language } from "../../languageProvider/language/language";
import { defaultLanguage } from "../../helper/utility";

const IndexNav = (props) => {
  const [isActive, toggleActive] = useState(false);

  const routerLinkLeaflet =
    global.preview_id !== undefined
      ? `/leaflet?id=${global.preview_id}`
      : "/leaflet";

  let indexClass = isActive
    ? "nav-link main-list active"
    : "nav-link main-list";

  return (
    <Fragment>
      <li
        className={props.mini === "on" ? "li_sidebar" : ""}
        id="indexIconSidebar"
      >
        <Link
          to={routerLinkLeaflet}
          style={{ cursor: "pointer" }}
          onClick={() => {
            props.setIndex();
          }}
          onMouseDown={() => toggleActive(!isActive)}
          onMouseUp={() => toggleActive(!isActive)}
          className={indexClass}
        >
          <i title="Indice" className="far fa-list-alt"></i>
          <p
            style={{
              opacity: props.mini === "on" ? null : "1",
              visibility: "visible"
            }}
            className={props.mini ? "fade_p" : ""}
          >
            {language[defaultLanguage].indice}
          </p>
        </Link>
      </li>
    </Fragment>
  );
};

const SearchNav = (props) => {
  const [openModal, setOpenModal] = useState(false);
  const [indexTooltip, toggleTooltip] = useState(false);

  return (
    <Fragment>
      <li
        style={{ position: "relative" }}
        onMouseEnter={() => {
          if (props.mini === "on") toggleTooltip(true);
        }}
        onMouseLeave={() => toggleTooltip(false)}
        className="nav-link main-list"
      >
        {indexTooltip && !isMobile && (
          <span
            style={{
              cursor: "pointer",
              position: "absolute",
              width: "75px",
              textAlign: "center",
              zIndex: 1,
              backgroundColor: serverResponse.config.tertiary_color,
              fontSize: "13px",
              padding: "3px 5px",
              left: 0,
              right: 0,
              marginLeft: "auto",
              marginRight: "auto",
              borderRadius: "0.25rem",
              top: "-10px",
              fontWeight: "900",
              lineHeight: "15px"
            }}
          >
            Ricerca <br />
            Ordine
          </span>
        )}
        <div className="nav-link main-list">
          <FontAwesomeIcon
            style={{ fontSize: 18, cursor: "pointer" }}
            onClick={() => setOpenModal(true)}
            icon={faSearch}
          />
        </div>
      </li>
      <RetrieveCart setOpenModal={setOpenModal} isOpen={openModal} />
    </Fragment>
  );
};

const Sidebar = (props) => {
  let listNameStyle;
  let sidebar;
  let appNameStyle = {};

  const {
    mini,
    drawerWidth,
    miniDrawerWidth,
    sidebarTheme,
    closeDrawer,
    themeSetting
  } = props;

  const reopenTutorial = () => {
    reloadTutorial();
  };

  let redirect = "https://www.volantinointerattivo.net/";
  if (serverResponse.config.custom_link)
    redirect = serverResponse.config.custom_link;

  if (themeSetting.sidebarTransParentValue === "on") {
    sidebar = {
      backgroundImage: `linear-gradient(0deg,rgba(0, 0, 0, 0.8),rgba(0, 0, 0, 0.9)),url(${themeSetting.transparentImage})`,
      backgroundRepeat: "no-repeat, repeat",
      backgroundPosition: "center",
      backgroundSize: "cover",
      width: mini ? miniDrawerWidth : drawerWidth,
      "@media (max-width: 991px)": {
        width: mini ? 0 : drawerWidth
      }
    };
  } else {
    sidebar = {
      width: mini ? miniDrawerWidth : drawerWidth,
      background: sidebarTheme.backgroundColor,
      "@media (max-width: 991px)": {
        width: mini ? 0 : drawerWidth
      }
    };
  }

  const closeIcon = {
    "@media (max-width: 991px)": {
      display: "block"
    }
  };

  if (mini) {
    listNameStyle = {
      opacity: miniDrawerWidth === drawerWidth ? 1 : 0,
      transform:
        miniDrawerWidth === drawerWidth
          ? "translateZ(0)"
          : "translate3d(-25px,0,0)"
    };
    if (isIE) {
      appNameStyle = {
        height: miniDrawerWidth === drawerWidth ? "" : "0px"
      };
    }
  } else {
    listNameStyle = {
      opacity: !mini ? 1 : 0,
      transform: !mini ? "translateZ(0)" : "translate3d(-25px,0,0)"
    };
    if (isIE) {
      appNameStyle = {
        height: !mini ? "" : "0px"
      };
    }
  }
  return (
    <SidebarWrapper
      className="d-none d-lg-block"
      themeSetting={themeSetting}
      sidebarTheme={sidebarTheme}
      mini={mini}
      miniDrawerWidth={miniDrawerWidth}
      drawerWidth={drawerWidth}
    >
      <div id="sidebar" className="sidebar sideBack" style={sidebar}>
        <div className="sidebar-header">
          <NavLink
            to={"/"}
            className="simple-text logo-mini"
            onClick={() => {
              if (!serverResponse.config.no_link_to_site)
                window.open(redirect, "_blank");
            }}
          >
            <div className="logo-img">
              <img src={iconDemo} alt="react-logo" />
            </div>
          </NavLink>

          {!serverResponse.config.no_link_to_site && (
            <a href={redirect} rel="noopener noreferrer" target="_blank">
              <div
                className="logo-text simple-text custom-sidebar-header"
                style={appNameStyle}
              >
                <img
                  src={iconAppName}
                  className={
                    serverResponse.config.small_logo
                      ? "logo_small"
                      : "logo_full"
                  }
                  alt="react-logo"
                />
              </div>
            </a>
          )}
          {serverResponse.config.no_link_to_site && (
            <div
              className="logo-text simple-text custom-sidebar-header"
              style={appNameStyle}
            >
              <img
                src={iconAppName}
                className={
                  serverResponse.config.small_logo ? "logo_small" : "logo_full"
                }
                alt="react-logo"
              />
            </div>
          )}
        </div>
        <div
          className="close-drawer-icon"
          style={closeIcon}
          onClick={closeDrawer()}
        >
          <i className="fas fa-times-circle" />
        </div>

        <div className="sidebar-wrapper">
          <ul className="nav">
            {serverResponse.leaflet.index !== null && (
              <IndexNav
                mini={props.themeSetting}
                setIndex={() => props.setIndexCarousel(0)}
                listNameStyle={listNameStyle}
              />
            )}

            {sidebarData.map((list, i) => {
              return (
                <Fragment key={i}>
                  {list.type && list.type === "heading" ? (
                    (!mini || miniDrawerWidth === drawerWidth) && (
                      <div className="sidelist-header-name">{list.name}</div>
                    )
                  ) : (
                    <NavList
                      listNameStyle={listNameStyle}
                      list={list}
                      mini={mini}
                      miniDrawerWidth={miniDrawerWidth}
                      drawerWidth={drawerWidth}
                      forceDrawerMini={props.forceDrawerMini}
                      {...props}
                    />
                  )}
                </Fragment>
              );
            })}
            {serverResponse.hasOwnProperty("video_categories") && (
              <li>
                <button className="nav-link main-list" onClick={reopenTutorial}>
                  <i className="fas fa-play-circle"></i>
                  <p style={listNameStyle}>
                    {language[defaultLanguage].video_tutorial}
                  </p>
                </button>
              </li>
            )}
            {serverResponse.config.sidebar.includes("share") && (
              <ShareFlyer
                forceDrawerMini={props.forceDrawerMini}
                pStyle={listNameStyle}
              />
            )}
          </ul>
          {/* <SearchNav mini={props.themeSetting} /> */}
          {/* <div style={{position: "absolute", bottom: "0px"}}>Powered by Luigi D'Arco</div> */}
        </div>
      </div>
    </SidebarWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    themeSetting: state.themeSetting.sidebarMiniValue
  };
};

export default withRouter(
  connect(mapStateToProps, { setIndexCarousel })(Radium(Sidebar))
);
